const mobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

let canvasWrapper = document.querySelector("#canvas-wrapper");


copyCanvasAttrs(document.querySelector(".canvas-link"));

document.querySelectorAll(".canvas-link").forEach((link) => {
    link.addEventListener("click", (e) => {
        e.preventDefault();
        copyCanvasAttrs(link);
        updateData();

        link.after(canvasWrapper);

        document.querySelectorAll(".canvas-link").forEach(link_item=>{
            if(link_item != link) {
                link_item.classList.add('canvas-link--hide-canvas');
            }
        })

        link.classList.toggle('canvas-link--hide-canvas');

        canvasWrapper.classList.remove('hidden');
        
        reload();
    });
});

function copyCanvasAttrs(link) {
    [...link.attributes].map(({ name, value }) => {
        if (name.includes("data-bundle")) {
            canvasWrapper.setAttribute(name, value);
        }
    });
}

wrapper = canvasWrapper;

let 
    entrance_curbs,
    drain_position,
    brand_name,
    pan_depth,
    pan_width,
    drain_back_measurement,
    drain_side_measurement,
    curb_width,
    curb_height,
    canvasRef;

function updateData() {
    entrance_curbs = wrapper.dataset.bundleCurbStyle;
    drain_position = "side-drain";
    if (wrapper.dataset.bundleSku.includes("B-PVC") || wrapper.dataset.bundleSku.includes("BBF-PVC") || wrapper.dataset.bundleSku.includes("B-CD") || wrapper.dataset.bundleSku.includes("BBF-CD")) {
        drain_position = "back-drain";
    }
    brand_name = wrapper.dataset.bundleBrand;
    pan_depth = +wrapper.dataset.bundlePanDepth.split(" ")[0];
    pan_width = +wrapper.dataset.bundlePanWidth.split(" ")[0];
    drain_back_measurement =
        +wrapper.dataset.bundleDrainBackPosition.split(" ")[0];
    drain_side_measurement =
        +wrapper.dataset.bundleDrainSidePosition.split(" ")[0];
    curb_width = +wrapper.dataset.bundleCurbWidth?.split(" ")[0] || 4.5;
    curb_height = +wrapper.dataset.bundleCurbHeight?.split(" ")[0] || 4.5;
    canvasRef = wrapper;

}

let canvasWidth = 652;
let canvasHeight = 600;
const canvasMinWidth = 550;
const incrementalScaleValue = 0.1;
const animationSpeed = 1;
const animationStore = {};

let Pan;
let store = {};
let adjustedScale;
let autoLeftMargin;

const getAnimatedValues = (selectedOptions) => {
    if(mobile()) {
        return { ...selectedOptions };
    }
    [
        "panWidth",
        "panDepth",
        "curbHeight",
        "curbWidth",
        "drainBackMeasurement",
        "drainSideMeasurement",
    ].forEach((v) => {
        const delta = +Math.abs(animationStore[v] - selectedOptions[v]);

        if (delta < animationSpeed) {
            animationStore[v] = selectedOptions[v];
        } else if (animationStore[v] < selectedOptions[v]) {
            animationStore[v] += animationSpeed;
        } else if (animationStore[v] > selectedOptions[v]) {
            animationStore[v] -= animationSpeed;
        } else {
            animationStore[v] = selectedOptions[v];
        }
    });

    return { ...animationStore };
};

const renderCompleted = (selectedOptions) => {
    const current = JSON.stringify(store);
    const future = JSON.stringify(selectedOptions);
    return current === future;
};

function getTransformedOptions() {
    const defaultState = {
        drain_position: drain_position
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
        drain_finish: "Polished Chrome", // ?????
        entrance_curbs: entrance_curbs
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
        brand_name: brand_name
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
        pan_depth: pan_depth,
        pan_width: pan_width,
        drain_back_measurement: drain_back_measurement,
        drain_side_measurement: drain_side_measurement,
        retailer: "Webstore",
        curb_width: curb_width,
        curb_height: curb_height,
    };


    return {
        panWidth: +defaultState.pan_width,
        panDepth: +defaultState.pan_depth,
        curbWidth: +defaultState.curb_width,
        curbHeight: +defaultState.curb_height,
        drainBackMeasurement: +defaultState.drain_back_measurement,
        drainSideMeasurement: +defaultState.drain_side_measurement,
        curbType: defaultState.entrance_curbs,
        grateStyle: brandGrateMap[defaultState.brand_name],
        grateFinish: defaultState.drain_finish,
        drainPosition: drainPositionMap[defaultState.drain_position],
        retailer: "Webstore",
    };
}

//-------------------------------------------------------------------------------------------
// General Code

updateData();

let selectedOptions = getTransformedOptions();

function reload() {
    selectedOptions = getTransformedOptions();
    redraw();
}

function setup() {
    const { scale, leftMargin } = specConfig;
    adjustedScale = scale;

    autoLeftMargin = leftMargin;

    canvasWidth = canvasRef ? canvasRef.offsetWidth : 500;

    createCanvas(canvasWidth, canvasHeight).parent(canvasRef);

    Pan = new PanBuilder(p5, 0, 0, adjustedScale);
    
    if(mobile()) {
        noLoop();
    }
}

function draw() {
    const { curbType, grateStyle, drainPosition } = selectedOptions;

    const { topMargin } = specConfig;

    const animatedValues = getAnimatedValues(selectedOptions);

    const {
        panWidth,
        panDepth,
        drainBackMeasurement,
        drainSideMeasurement,
        curbHeight,
        curbWidth,
    } = animatedValues;

    if (
        renderCompleted(selectedOptions) &&
        canvasWidth >= canvasRef.offsetWidth
    ) {
        return;
    }

    if (canvasWidth !== canvasRef.offsetWidth) {
        canvasWidth = canvasRef.offsetWidth;
        resizeCanvas(canvasWidth, canvasHeight);
    }

    // Small device adjustments
    if (canvasWidth < canvasMinWidth) {
        canvasWidth = 550;
        canvasHeight = 550;
        autoLeftMargin = 50;
        resizeCanvas(canvasWidth, canvasHeight);
    }

    const inputWidth = +panWidth;
    const inputDepth = +panDepth;
    const inputDrainY = +drainBackMeasurement;
    const inputDrainX = +drainSideMeasurement;
    const inputCurbWidth = +curbWidth;
    const inputCurbHeight = +curbHeight;
    const panDepthScaled = Math.round(inputDepth * adjustedScale);
    const panWidthScaled = Math.round(inputWidth * adjustedScale);

    const frontViewPositionBuffer = topMargin + panDepthScaled + 300;

    if (canvasHeight !== frontViewPositionBuffer) {
        canvasHeight = frontViewPositionBuffer;
        resizeCanvas(canvasWidth, canvasHeight);
    }

    const sideViewBuffer = 300;
    const sideViewPositionBuffer =
        autoLeftMargin + panWidthScaled + sideViewBuffer;

    const topViewBottomMargin = 130;
    const topViewRightMargin = 150;
    const sideViewPosition =
        autoLeftMargin + panWidthScaled + topViewRightMargin;
    const frontViewPosition = topMargin + panDepthScaled + topViewBottomMargin;

    // Setup some default canvas state
    background(255);
    fill(0);
    textSize(20);
    stroke("black");
    strokeWeight(0);
    textFont("Droid Sans");
    push();

    stroke("black");
    noFill();
    strokeWeight(1);

    push();

    // Draw Top View of Pan
    translate(autoLeftMargin, topMargin);

    Pan.scale(adjustedScale);
    Pan.dimensions(inputWidth, inputDepth);
    Pan.drainLocation(inputDrainX, inputDrainY, drainPosition);
    Pan.curbType(curbType);

    if (curbType === "Barrier Free") {
        Pan.curbWidth(0);
        Pan.curbHeight(0);
    } else {
        Pan.curbWidth(inputCurbWidth);
        Pan.curbHeight(inputCurbHeight);
    }

    Pan.splashWallWidth(panBaseSpec.splashWallWidthInches);
    Pan.grateStyle(grateStyle);

    Pan.render("top");

    pop();
    push();

    translate(sideViewPosition, topMargin);
    Pan.render("side");

    pop();
    push();

    translate(autoLeftMargin, frontViewPosition);
    Pan.render("front");

    pop();
    push();
    translate(0, topMargin + 700);

    const boxBuffer = 50;

    if (sideViewPositionBuffer >= canvasWidth) {
        adjustedScale -= incrementalScaleValue;
    } else if (sideViewPositionBuffer < canvasWidth - boxBuffer) {
        adjustedScale += incrementalScaleValue;
    } else {
        store = { ...selectedOptions, ...animatedValues };
    }
}
